'use client';

import { getCDNURL } from '@pickleballinc/lib/get-cdn-url';
import { BallProductCard } from '@pickleballinc/ui/components/global/Cards/BallProductCard';

import ImageWithFallback from '@/components/atoms/ImageWithFallback';
import { PICKLEBALL_CENTRAL_LOGO, TEAM_LEAGUES_PLACEHOLDER_IMAGE } from '@/components/constants/constants';
import { BallProduct } from '@/infrastructure/network/data/system-location-balls/types';

interface BallCardProps {
	product: BallProduct;
	ballIndex: number;
	ballCount: number;
	onPreviousBall: () => void;
	onNextBall: () => void;
}

export const BallCard = ({ product, ballIndex, ballCount, onPreviousBall, onNextBall }: BallCardProps) => (
	<BallProductCard
		application="team-leagues"
		fallbackImageUrl={getCDNURL(TEAM_LEAGUES_PLACEHOLDER_IMAGE, 312, 312)}
		product={product}
		title="Team league ball"
		logo={<img src={PICKLEBALL_CENTRAL_LOGO} alt="Pickleball Central" width={100} height={24} />}
		imageRenderer={(props) => <ImageWithFallback {...props} />}
		ballIndex={ballIndex}
		ballCount={ballCount}
		onPreviousBall={onPreviousBall}
		onNextBall={onNextBall}
	/>
);
